import logo from './logo.svg';
import './App.css';
import TestComp from './tests/TestComp.js';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          react kennen lernen
        </a>
		<TestComp />
      </header>
    </div>
  );
}

export default App;
